import axios from "../index"

// 接口基础路径
const rootApi = '/api_v2/alarm'

/** 获取异常类型接口 */
export const getAlarmTypeList = () => {
  return axios.get(`${rootApi}/getTypeList`)
}

/** 根据异常类型获取报警项目接口 */
export const getAlarmProjectList = (params) => {
  return axios.get(`${rootApi}/getProjectList`, {params})
}

/** 上报异常 */
export const reportAlarm = (params) => {
  return axios.post(`${rootApi}/saveInfo`, params)
}

/** 获取异常报警列表 */
export const alarmRecordPage = (params) => {
  return axios.get(`${rootApi}/alarmRecordPage`, {params})
}